import { Box, Typography } from '@material-ui/core'
import { SIMILARITY_ACCURACY_DEFAULT } from 'constants/blocks'
import { Property } from 'contexts/Flow/types'
import { useForm } from 'contexts/Form/formContext'
import { useState } from 'react'
import useTranslator from 'utils/hooks/Translator'
import { SimilarityAccuracySlider } from './styles'

export function SimilarityAccuracy({ accuracy }: { accuracy: Property }) {
  const { state, updateForm } = useForm()
  const { getTranslation } = useTranslator()
  const { dataForm } = state

  const [similarityAccuracy, setSimilarityAccuracy] = useState<number>(
    dataForm?.similarityAccuracy || SIMILARITY_ACCURACY_DEFAULT,
  )

  function handleChangeSimilarityAccuracy(value: number | number[]) {
    if (!dataForm) return
    dataForm.similarityAccuracy = Number(value)
    updateForm(dataForm)
  }

  return (
    <Box component="div">
      <Typography variant="subtitle2">{getTranslation('accuracy')}</Typography>

      <Box
        component="div"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 16,
          padding: '8px',
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 'bolder' }}>
          {accuracy.min}
        </Typography>

        <SimilarityAccuracySlider
          defaultValue={similarityAccuracy}
          value={similarityAccuracy}
          onChange={(_, value) => setSimilarityAccuracy(Number(value))}
          onChangeCommitted={(_, value) =>
            handleChangeSimilarityAccuracy(value)
          }
          getAriaValueText={(value) => `${value}`}
          aria-labelledby="similarity-accuracy-slider"
          valueLabelDisplay="auto"
          step={accuracy.step}
          min={accuracy.min}
          max={accuracy.max}
          marks
          style={{
            marginLeft: 8,
            marginRight: 8,
          }}
        />

        <Typography variant="subtitle1" style={{ fontWeight: 'bolder' }}>
          {accuracy.max}
        </Typography>
      </Box>

      <Typography
        variant="h6"
        style={{
          width: 'fit-content',
          fontWeight: 'bolder',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        {similarityAccuracy}
      </Typography>
    </Box>
  )
}
